import React, { useState } from 'react';
import { useSaveValidationMutation } from '../../store';
import { Modal } from '../../components';
import { Spinner } from '@swegon-core/ui-components';

export const SaveValidationModal = (props) => {
    const { show, data, projectId, onClose } = props;
    const [startSaving, setStartSaving] = useState(false);
    const [saveValidations] = useSaveValidationMutation();

    const handleSubmit = () => {
        setStartSaving(true);
        saveValidations({ id: projectId, ...data });
        setStartSaving(false);
        onClose();
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                <div className="mt-2 mb-2 px-2">
                    {!startSaving
                        ? 'Ready to save validation results'
                        : 'Saving validation results ...'}
                </div>
                <div className="px-4 sm:flex mb-4 justify-center">
                    {startSaving && <Spinner color="green" />}
                </div>
                <div className="px-4 py-3 sm:flex sm:px-6 justify-end">
                    <button
                        onClick={handleSubmit}
                        type="button"
                        className="swegon-like-button contained !px-4"
                        disabled={startSaving}
                    >
                        Save
                    </button>
                </div>
            </div>
        </Modal>
    );
};
